
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, List, ListSubheader, Toolbar, Typography, AppBar, } from '@material-ui/core';
import MBackIcon from '../view/MBackIcon';
import AnchorTopItem from './view/AnchorTopItem';
import AnchorItem from './view/AnchorItem';
import Apis from '../../network/Apis';
import MStatusBar from '../view/MStatusBar';
import AppData from '../../model/AppData';


class AnchorRank extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            data: [],
        };
    }

    componentDidMount() {
        this.getAnchorRanking();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getAnchorRanking = async () => {
        let result = await Apis.encryptionHostPaiHang();
        console.log('getAnchorRanking', result);
        if (result.code == 200) {
            for (let i = 0; i < result.data.length; i++) {
                let isStart = AppData.isStarAnchor(result.data[i].user_id);
                result.data[i].isStart = isStart;
            }
            this.setState({ data: result.data });
        }
    }

    _onClick = (item) => {
        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }

        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            if (data[i].user_id == item.user_id) {
                data[i].isStart = !data[i].isStart;
            }
        }

        let isStart = !item.isStart;
        if (isStart) {
            this.starAnchor(item.user_id);
        } else {
            this.unStarAnchor(item.user_id);
        }

        this.setState({ data: data });
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    starAnchor = async (user_id) => {
        let result = await Apis.encryptionFocusHost(JSON.stringify([user_id]));
        console.log('starAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    unStarAnchor = async (user_id) => {
        let result = await Apis.encryptionFocusHost(user_id, 1);
        console.log('unStarAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    render() {
        const { classes, } = this.props;
        const { data } = this.state;
        let moreData = [];
        if (data.length > 3) {
            moreData = data.slice(3);
        }
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <List style={{ width: '100%' }}>
                        <ListSubheader className={classes.subheader}>
                            <AppBar className={classes.appbar}>
                                <MStatusBar />
                                <Toolbar style={{ justifyContent: 'center', alignItems: 'center' }}>
                                    <MBackIcon className={classes.backIcon} />
                                    <Typography className={classes.titleText}>明星主播</Typography>
                                </Toolbar>
                            </AppBar>
                        </ListSubheader>
                        <Grid container direction='column' style={{ marginTop: 48 }} >
                            <MStatusBar />
                            <Grid container direction='row' alignItems='center' justify='space-around' >
                                <Grid container justify='center' style={{ width: '30vw', paddingTop: 48 }}>
                                    {
                                        data.length > 1 && <AnchorTopItem idx={1} data={data[1]} onClick={() => this._onClick(data[1])} onClickAnchor={() => this._onClicAnchor(data[1])} />
                                    }
                                </Grid>
                                <Grid container justify='center' style={{ width: '30vw' }}>
                                    {
                                        data.length > 0 && <AnchorTopItem idx={0} data={data[0]} onClick={() => this._onClick(data[0])} onClickAnchor={() => this._onClicAnchor(data[0])} />
                                    }
                                </Grid>
                                <Grid container justify='center' style={{ width: '30vw', paddingTop: 48 }}>
                                    {
                                        data.length > 2 && <AnchorTopItem idx={2} data={data[2]} onClick={() => this._onClick(data[2])} onClickAnchor={() => this._onClicAnchor(data[2])} />
                                    }
                                </Grid>
                            </Grid>
                            <Grid style={{ marginTop: 16 }}>
                                {
                                    moreData && moreData.map((item, i) => (
                                        <AnchorItem key={i} idx={i + 4} data={item} onClick={() => this._onClick(item)} onClickAnchor={() => this._onClicAnchor(item)} />
                                    ))
                                }
                            </Grid>
                        </Grid>

                    </List>
                </div>
            </React.Fragment >
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        backgroundSize: 'cover',
        width: '100vw',
        display: "flex",
        backgroundColor: '#201C24',
        flexDirection: "column",
        alignItems: 'center',
    },
    subheader: {
        width: '100%',
        padding: theme.spacing(0, 0, 0, 0),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    appbar: {
        backgroundColor: 'transparent',
        flexDirection: 'rows',
        boxShadow: 'none',
    },
    titleText: {
        fontSize: 17,
        color: '#FFFFFF',
    },
    backIcon: {
        color: '#FFF'
    }


}))(AnchorRank));